import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PendingGlyph } from "../glyphs.js";
const HEIGHT = { sm: 30, md: 36, lg: 46 };
const PAD = { sm: "0 var(--space-15)", md: "0 var(--space-2)", lg: "0 22px" };
/**
 * Stateful paint is indirected (ADR 0036 clause 7): the real property reads a local custom
 * property with the resting token as its fallback, and only `interactions.css` sets the
 * local one, on `:hover`, `:active`, `:disabled` and inside a notice. Nothing here sets
 * `--button-*`.
 */
const REST = {
    primary: { bg: "var(--accent)", ink: "var(--on-accent)", edge: "none" },
    secondary: { bg: "var(--tone)", ink: "var(--ink-1)", edge: "none" },
    quiet: { bg: "transparent", ink: "var(--ink-1)", edge: "none" },
    destructive: {
        bg: "transparent",
        ink: "var(--ink-1)",
        edge: "inset 0 0 0 var(--border-hairline) var(--ink-3)",
    },
};
export function Button({ children, variant = "secondary", size = "md", fullWidth = false, disabled = false, iconLeft, pending = false, as = "button", newTab = false, style, ...rest }) {
    const Tag = as;
    const quiet = variant === "quiet";
    const look = REST[variant];
    return (_jsxs(Tag, { "data-button": variant, "data-size": size, disabled: Tag === "button" ? disabled : undefined, "aria-disabled": Tag !== "button" && disabled ? true : undefined, target: newTab ? "_blank" : undefined, rel: newTab ? "noopener noreferrer" : undefined, style: {
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            gap: "var(--space-1)", flex: "none", whiteSpace: "nowrap", border: "none", margin: 0,
            boxSizing: "border-box",
            height: quiet ? undefined : HEIGHT[size],
            padding: quiet ? 0 : PAD[size],
            width: fullWidth ? "100%" : undefined,
            borderRadius: quiet ? "var(--radius-inline)" : "var(--radius-control)",
            fontFamily: "var(--font-sans)",
            fontSize: size === "sm" ? "var(--type-small-size)" : "var(--type-body-size)",
            lineHeight: "var(--type-body-line)",
            fontWeight: "var(--type-body-weight-strong)",
            background: `var(--button-bg, ${look.bg})`,
            color: `var(--button-ink, ${look.ink})`,
            boxShadow: `var(--button-edge, ${look.edge})`,
            cursor: "var(--button-cursor, pointer)",
            textDecorationLine: quiet ? "underline" : "none",
            textDecorationColor: quiet ? "var(--button-underline, var(--ink-3))" : undefined,
            textDecorationThickness: quiet ? "var(--border-hairline)" : undefined,
            textUnderlineOffset: quiet ? "var(--space-05)" : undefined,
            transitionProperty: "background-color, color, text-decoration-color",
            transitionDuration: "var(--dur-fast)",
            transitionTimingFunction: "var(--ease-out)",
            ...style,
        }, ...rest, children: [pending && _jsx(PendingGlyph, {}), iconLeft, children] }));
}
